import Routes from './shared/routes';

const App = () => <Routes />;

export default App;
